import { useEffect, useState } from "react";
import Banner from "./banner";

const Banners = ({ type }) => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    fetch(`/api/banners_api.php?block=${type}`)
      .then((res) => res.json())
      .then((data) => setBanners(data))
      .catch((err) => console.error("Ошибка загрузки баннеров:", err));
  }, [type]);

  return (
    <section className="w-auto max-lg:w-[400px] max-smd:w-full flex justify-center items-center flex-wrap gap-3">
      {banners.map((b) => (
        <Banner  key={b.id} image={b.image_url} link={b.link_url} />
      ))}
    </section>
  );
};

export default Banners;
